export default __webpack_public_path__ + "static/media/brand-new-day-card.0eae09f8.jpg";